module.exports = __webpack_public_path__ + "img/FedEx.198df2d.svg";